module.exports = __webpack_public_path__ + "img/list-pattern1.c9c0fb0.svg";